import styled from 'styled-components'
import { theme } from '../../../styles/theme'

export const Container = styled.div`
  width: 62px;
  height: 62px;
  object-fit: contain;

  overflow: hidden;

  border-radius: ${theme.border.mediumRadius};
  background: ${theme.colors.mainBg};
`

export const Image = styled.img`
  width: 62px;
  height: 62px;
  object-fit: cover;
`
